const recommendationFormSelector = '[data-elx-cart-recommendation-form]';
const drawerSelector = 'cart-drawer-component';
const cartItemRowSelector = 'tbody .cart-items__table-row[data-key]';

let pendingDrawerRestore = false;
let pendingDrawerRestoreTimeout;

function scheduleAssociatedFilterLayout() {
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => arrangeAssociatedFilterRows());
  });
}

function arrangeAssociatedFilterRows() {
  document.querySelectorAll(`${drawerSelector} cart-items-component[data-drawer]`).forEach((component) => {
    const rows = [...component.querySelectorAll(cartItemRowSelector)];
    const rowGroup = rows[0]?.closest('tbody');
    if (!rowGroup) return;

    rows.forEach((row) => {
      row.style.removeProperty('order');
      row.classList.remove('elx-cart-line--association-start');
    });
    rowGroup.classList.remove('elx-cart-items--associated-groups');

    const primaryRows = rows.filter((row) => !row.dataset.elxAssociatedParentId);
    let order = 0;
    const assignedRows = new Set();

    primaryRows.forEach((parentRow) => {
      parentRow.style.order = String(order++);
      assignedRows.add(parentRow);

      const associatedRows = rows
        .filter((row) => row.dataset.elxAssociatedParentId === parentRow.dataset.elxProductId)
        .sort((left, right) => {
          const leftRank = Number(left.dataset.elxAssociatedFilterRank) || Number.MAX_SAFE_INTEGER;
          const rightRank = Number(right.dataset.elxAssociatedFilterRank) || Number.MAX_SAFE_INTEGER;
          return leftRank - rightRank;
        });

      if (!associatedRows.length) return;

      rowGroup.classList.add('elx-cart-items--associated-groups');
      const associationLabel = associatedRows
        .map((row) => row.querySelector('.elx-cart-line__association-label'))
        .find(Boolean);
      const firstAssociatedInfo = associatedRows[0].querySelector('.cart-items__product-info');
      if (associationLabel && firstAssociatedInfo && associationLabel.parentElement !== firstAssociatedInfo) {
        firstAssociatedInfo.prepend(associationLabel);
      }

      associatedRows.forEach((row, index) => {
        row.style.order = String(order++);
        row.classList.toggle('elx-cart-line--association-start', index === 0);
        assignedRows.add(row);
      });
    });

    rows
      .filter((row) => !assignedRows.has(row))
      .forEach((row) => {
        row.style.order = String(order++);
      });
  });
}

function restoreDrawerAfterCartUpdate() {
  if (!pendingDrawerRestore) return;

  const drawer = document.querySelector(drawerSelector);
  const dialog = drawer?.querySelector('[data-testid="cart-drawer-dialog"]');
  if (!drawer || !dialog) return;

  pendingDrawerRestore = false;
  window.clearTimeout(pendingDrawerRestoreTimeout);
  drawer.open?.();
}

function preserveOpenDrawer(event) {
  const cartItems = event.target instanceof Element ? event.target.closest('cart-items-component[data-drawer]') : null;
  const drawer = cartItems?.closest(drawerSelector);
  const dialog = drawer?.querySelector('[data-testid="cart-drawer-dialog"]');
  const source = event.detail?.data?.source;

  if (source !== 'cart-items-component' || !dialog?.open) return;

  pendingDrawerRestore = true;
  window.clearTimeout(pendingDrawerRestoreTimeout);
  pendingDrawerRestoreTimeout = window.setTimeout(() => {
    pendingDrawerRestore = false;
  }, 5000);

  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(restoreDrawerAfterCartUpdate);
  });
}

function observeCartItemHydration() {
  const observer = new MutationObserver((records) => {
    const cartRowsWereAdded = records.some((record) =>
      [...record.addedNodes].some(
        (node) =>
          node instanceof Element &&
          (node.matches('.cart-items__table-row[data-key]') || node.querySelector('.cart-items__table-row[data-key]'))
      )
    );

    if (cartRowsWereAdded) scheduleAssociatedFilterLayout();
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

function updateStatus(form, message) {
  const drawer = form.closest('cart-drawer-component');
  const status = drawer?.querySelector('[data-elx-cart-drawer-status]');
  if (status) status.textContent = message;
}

async function addRecommendation(form) {
  const variantId = Number(form.dataset.variantId);
  const button = form.querySelector('[data-elx-cart-recommendation-add]');
  const label = button?.querySelector('.elx-cart-drawer__recommendation-add-label');
  const productTitle = form.dataset.productTitle || 'Item';

  if (!variantId || !button || button.disabled) return;

  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  if (label) label.textContent = 'Adding...';

  try {
    const addItemsToCart = window.ElxCartActions?.addItemsToCart;
    if (typeof addItemsToCart !== 'function') throw new Error('Shopping cart is still loading. Please try again.');

    await addItemsToCart({
      items: [{ id: variantId, quantity: 1 }],
      sourceId: 'elx-cart-drawer',
      source: 'elx-cart-drawer-recommendations',
    });
    if (label) label.textContent = 'Added';
    updateStatus(form, `${productTitle} added to cart.`);
  } catch (error) {
    if (label) label.textContent = 'Add to Cart';
    button.disabled = false;
    updateStatus(form, error?.message || 'Unable to add this item.');
  } finally {
    button.removeAttribute('aria-busy');
  }
}

document.addEventListener('submit', (event) => {
  const form = event.target.closest(recommendationFormSelector);
  if (!form) return;

  event.preventDefault();
  void addRecommendation(form);
});

document.addEventListener('cart:update', (event) => {
  preserveOpenDrawer(event);
  scheduleAssociatedFilterLayout();
});

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      observeCartItemHydration();
      scheduleAssociatedFilterLayout();
    },
    { once: true }
  );
} else {
  observeCartItemHydration();
  scheduleAssociatedFilterLayout();
}
